export const LEARN_BASE_ROUTE = 'learn';
export const EXPLORE_BASE_ROUTE = 'explore';
export const TRIALS_BASE_ROUTE = 'try';
export const COLLECTIONS_BASE_ROUTE = 'collections';
export const ORDERS_BASE_ROUTE = 'orders';

export const CONFIRMATION_ROUTE = 'confirmation';

export const Routes = {
    // Content
    LISTING: 'appxListingDetail',
    SEARCH: 'appxSearchKeywordResults',
    EXPLORE: `${EXPLORE_BASE_ROUTE}/:bucket`,
    LEARN: `${LEARN_BASE_ROUTE}/:slug`,
    LEARN_HOME: LEARN_BASE_ROUTE,
    FAVORITE_LISTINGS: 'appxSavedListings',
    TRIALS: TRIALS_BASE_ROUTE,
    TRIALS_CONFIRMATION: `${TRIALS_BASE_ROUTE}/${CONFIRMATION_ROUTE}`,
    COLLECTION: `${COLLECTIONS_BASE_ROUTE}/:slug`,
    COLLECTIONS_HOME: COLLECTIONS_BASE_ROUTE,
    ORDERS: ORDERS_BASE_ROUTE,

    // WIP: Consultants and content listings are still in legacy
    CONTENT_LISTING: 'appxContentListingDetail',
    CONSULTANT_LISTING: 'appxConsultingListingDetail',

    // Auth
    CALLBACK: 'callback',
    LOGIN: 'login',
    SIGN_UP: 'signup',

    // Misc
    HOME: '/',
    ERROR: 'error',
    NOT_FOUND: '*',
} as const;

export const ORDERS_PARAMS = {
    ORG_ID: 'orgId',
    TAB: 'tab',
    PAGE: 'page',
    SORT_BY: 'sortBy',
    SORT_ORDER: 'sortOrder',
    PAYMENT_TYPE: 'paymentType',
    STATUS: 'status',
} as const;

export type OrdersQueryParams = (typeof ORDERS_PARAMS)[keyof typeof ORDERS_PARAMS];

export type Route = (typeof Routes)[keyof typeof Routes];
